import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	gap: "8",
	marginBottom: "16",
	alignSelf: "center",
});
